<template lang="html" src="./rail-path.html"></template>
<style lang="scss" scoped src="./rail-path.scss"></style>

<script>
export default {
  name: "RailPath"
};
</script>
